export default __webpack_public_path__ + "static/media/home.d42c8676.svg";